module.exports = __webpack_public_path__ + "img/7.4543ab7d.webp";